"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Select_1 = __importDefault(require("../Select"));
var MultiSelectList_1 = __importDefault(require("./MultiSelectList"));
var VirtualRowRenderer_1 = __importDefault(require("./VirtualRowRenderer"));
var useInitData_1 = require("./hooks/useInitData");
var useHandlers_1 = require("./hooks/useHandlers");
var useLifeCycle_1 = require("./hooks/useLifeCycle");
var useStatusSelectedItems_1 = __importDefault(require("./hooks/useStatusSelectedItems"));
var MultiSelect = function (_a) {
    var _b = _a.progress, progress = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.classes, classes = _d === void 0 ? {
        select: {},
        formControl: {}
    } : _d, _e = _a.autoWidth, autoWidth = _e === void 0 ? false : _e, _f = _a.defaultValue, defaultValue = _f === void 0 ? null : _f, IconComponent = _a.IconComponent, id = _a.id, inputProps = _a.inputProps, _g = _a.label, label = _g === void 0 ? null : _g, labelId = _a.labelId, _h = _a.labelWidth, labelWidth = _h === void 0 ? 0 : _h, MenuProps = _a.MenuProps, onChange = _a.onChange, onOpen = _a.onOpen, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, SelectDisplayProps = _a.SelectDisplayProps, _j = _a.value, value = _j === void 0 ? null : _j, _k = _a.variant, variant = _k === void 0 ? 'standard' : _k, _l = _a.fullWidth, fullWidth = _l === void 0 ? false : _l, _m = _a.helperText, helperText = _m === void 0 ? '' : _m, _o = _a.placeholder, placeholder = _o === void 0 ? '' : _o, field = _a.field, _p = _a.items, items = _p === void 0 ? [] : _p, renderItem = _a.renderItem, _q = _a.error, error = _q === void 0 ? false : _q, _r = _a.readOnly, readOnly = _r === void 0 ? false : _r, _s = _a.disabled, disabled = _s === void 0 ? false : _s, _t = _a.showCheckbox, showCheckbox = _t === void 0 ? true : _t, renderValue = _a.renderValue, onSearch = _a.onSearch, _u = _a.showApplyButton, showApplyButton = _u === void 0 ? false : _u, formatMessage = _a.formatMessage, applyButtonProps = _a.applyButtonProps, maxSelectedItems = _a.maxSelectedItems;
    var _v = (0, useInitData_1.useInitData)({ defaultValue: defaultValue || value }), sessionItems = _v.sessionItems, searchStr = _v.search, isLoading = _v.isLoading, open = _v.open, selectedItemsMap = _v.selectedItemsMap, dispatch = _v.dispatch, amountItems = _v.amountItems, listItems = _v.listItems, allSelectedItemsMap = _v.allSelectedItemsMap, allSelectedItems = _v.allSelectedItems;
    var statusSelectedItems = (0, useStatusSelectedItems_1.default)(allSelectedItems, listItems);
    var _w = (0, useHandlers_1.useHandlers)({
        sessionItems: sessionItems,
        dispatch: dispatch,
        selectedItemsMap: selectedItemsMap,
        items: items,
        listItems: listItems,
        onSearch: onSearch,
        placeholder: placeholder,
        onChange: onChange,
        allSelectedItems: allSelectedItems,
        field: field,
        showApplyButton: showApplyButton,
        onOpen: onOpen
    }), handlerSearch = _w.handlerSearch, handlerChange = _w.handlerChange, getValue = _w.getValue, handlerClose = _w.handlerClose, handlerOpen = _w.handlerOpen, handlerAllChange = _w.handlerAllChange, handlerApply = _w.handlerApply;
    (0, useLifeCycle_1.useLifecycle)({
        dispatch: dispatch,
        value: value,
        open: open
    });
    var rowRenderer = (0, react_1.useMemo)(function () { return (0, VirtualRowRenderer_1.default)({
        items: listItems,
        value: allSelectedItemsMap,
        handlerChange: handlerChange,
        showCheckbox: showCheckbox,
        classes: classes,
        renderItem: renderItem
    }); }, [
        listItems,
        allSelectedItemsMap,
        handlerChange,
        showCheckbox,
        classes,
        renderItem
    ]);
    return (react_1.default.createElement(Select_1.default, { multiple: true, displayEmpty: true, renderValue: renderValue || getValue, progress: progress, required: required, classes: classes, autoWidth: autoWidth, defaultValue: defaultValue, IconComponent: IconComponent, id: id, inputProps: inputProps, label: label, labelId: labelId, labelWidth: labelWidth, MenuProps: MenuProps, onClose: handlerClose, onOpen: handlerOpen, open: open, SelectDisplayProps: SelectDisplayProps, value: value, variant: variant, fullWidth: fullWidth, helperText: helperText, placeholder: placeholder, field: field, items: items, error: error, readOnly: readOnly, disabled: disabled || progress, startAdornment: startAdornment, endAdornment: endAdornment },
        react_1.default.createElement(MultiSelectList_1.default, { label: label, search: searchStr, handleSearch: handlerSearch, rowCount: amountItems, rowRenderer: rowRenderer, isLoading: isLoading, handlerAllChange: handlerAllChange, showCheckbox: showCheckbox, classes: classes, placeholder: placeholder, value: value, statusSelectedItems: statusSelectedItems, showApplyButton: showApplyButton, handlerApply: handlerApply, formatMessage: formatMessage, applyButtonProps: __assign({ disabled: typeof maxSelectedItems === 'number' ? allSelectedItems.length >= maxSelectedItems : false }, (applyButtonProps || {})) })));
};
exports.default = MultiSelect;
